const loyaltyPointsCalculator = require('../../common/loyalty/loyalty-points-calculator');

class CartLoyaltyController {
    constructor($scope, featureService, settingsService, trolleyService, shopperService) {
        this.trolleyService = trolleyService;
        this.settingsService = settingsService;
        this.featureService = featureService;
        this.$scope = $scope;
        this.shopperService = shopperService;
        settingsService.getSettingValue('EverydayRewards', 'CardName').then((setting) => {
            this.rewardsCardName = setting;
        });
    }

    $onInit() {
        this.loadRewardsStatus(this.trolleyService.wowRewardsSummary);

        this.$scope.$watch(() => this.trolleyService.wowRewardsSummary, (summary) => {
            this.loadRewardsStatus(summary);
        });
    }

    loadRewardsStatus(summary) {
        this.rewardsEarned = summary && summary.WowRewardsEarned;
        this.rewardsToSpend = summary && summary.WowRewardsToSpend;

        this.preference = summary && summary.SaveForLaterPreference;
        this.preferenceDetail = {
            isQantas: this.preference === 'QantasPoints',
            isChristmas: this.preference === 'Christmas',
        };
        this.preferenceDetail.showPreference = this.preferenceDetail.isChristmas || this.preferenceDetail.isQantas;

        this.isLessThanMinimumRedemptionBalance = summary && summary.IsLessThanMinimumRedemptionBalance;
        this.isOptOutSaveForLaterAndBalanceIsLessThanMinimum = !this.preferenceDetail.showPreference && this.isLessThanMinimumRedemptionBalance;

        this.toSpendImageProperties = this.getToSpendImageProperties(this.preferenceDetail);
        this.screenReaderMessage = this.getScreenReaderMessage(this.preferenceDetail);
        this.toSpendDisplayMessage = this.getToSpendDisplayMessage(this.preferenceDetail, this.isLessThanMinimumRedemptionBalance);

        this.showRewardsToSpend = !this.preferenceDetail.isQantas && !this.isLessThanMinimumRedemptionBalance;
    }

    getToSpendImageProperties(preferenceDetail) {
        if (!preferenceDetail.showPreference) {
            return { srcName: 'icon-rewards-burn.svg', className: 'cartLoyalty-pointsToSpendIcon' };
        }

        if (preferenceDetail.showPreference && preferenceDetail.isQantas) {
            return { srcName: 'icon-rewards-qff-plane.svg', className: 'cartLoyalty-pointsQffIcon' };
        }

        if (preferenceDetail.showPreference && preferenceDetail.isChristmas) {
            return { srcName: 'icon-rewards-xmas-sock.svg', className: 'cartLoyalty-pointsXmasIcon' };
        }

        return { srcName: 'icon-tospend.png', className: 'cartLoyalty-pointsToSpendIcon' };
    }

    getToSpendDisplayMessage(preferenceDetail, isLessThanMinimumRedemptionBalance) {
        if (preferenceDetail.isQantas) {
            return 'CONVERTING TO<br/>QANTAS POINTS';
        }

        if (preferenceDetail.isChristmas) {
            return isLessThanMinimumRedemptionBalance ? 'SAVING<br/>FOR XMAS' : 'SAVED FOR XMAS';
        }

        return 'TO SPEND';
    }

    getScreenReaderMessage(preferenceDetail) {
        if (preferenceDetail.showPreference && preferenceDetail.isQantas) {
            return 'to save for Qantas';
        }

        if (preferenceDetail.showPreference && preferenceDetail.isChristmas) {
            return 'to save for Christmas';
        }

        return 'to spend';
    }

    getRewardsPoints() {
        return loyaltyPointsCalculator(this.rewardsEarned);
    }

    shouldShowWowRewardsSummary() {
        const isEnabledGetEdrPointsBalanceOnLogin =
            this.featureService.isEnabled(this.featureService.features.enableGetEdrPointsBalanceOnLogin);
        const isErrorInGettingWowRewardsBalance =
            this.trolleyService.wowRewardsSummary && this.trolleyService.wowRewardsSummary.IsErrorInGettingWowRewardsBalance;
        const isRegisteredWowRewardsCustomer =
            this.trolleyService.wowRewardsSummary && this.trolleyService.wowRewardsSummary.IsWowRewardsCardRegistered;

        return isEnabledGetEdrPointsBalanceOnLogin && !isErrorInGettingWowRewardsBalance && isRegisteredWowRewardsCustomer;
    }

    shouldShowRewardsSidebarCTA() {
        const isRegisteredWowRewardsCustomer =
            this.trolleyService.wowRewardsSummary && this.trolleyService.wowRewardsSummary.IsWowRewardsCardRegistered;
            // show sidebar if not registered to rewards and is not a guest
        return !isRegisteredWowRewardsCustomer && !this.shopperService.IsGuest;
    }
}

const cartLoyaltyComponentDefinition = {
    controller: ['$scope', 'FeatureService', 'SettingsService', 'TrolleyService', 'ShopperService', CartLoyaltyController],
    template: require('./cart-loyalty.component.html').trim(),
};

module.exports = {
    CartLoyaltyController,
    cartLoyaltyComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/cart/cart-loyalty.component.js